import { z } from 'zod';

export const createSupportFormSchema = (t: (key: string, options?: any) => string) =>
  z.object({
    issue: z
      .string()
      .min(10, t('common:error.minLength', { min: 10 }))
      .max(1000, t('common:error.maxLength', { max: 1000 })),
  });

export type SupportFormValues = z.infer<ReturnType<typeof createSupportFormSchema>>;
